"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadNewCurrencyFormat = void 0;
const numeral_1 = __importDefault(require("numeral"));
const config_1 = require("../config/config");
const loadNewCurrencyFormat = () => {
    numeral_1.default.register('locale', 'us-custom', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'Million',
            billion: 'Billion',
            trillion: 'Trillion'
        },
        ordinal(number) {
            const b = number % 10;
            return ~~((number % 100) / 10) === 1
                ? 'th'
                : b === 1
                    ? 'st'
                    : b === 2
                        ? 'nd'
                        : b === 3
                            ? 'rd'
                            : 'th';
        },
        currency: {
            symbol: '$'
        }
    });
    numeral_1.default.locale('us-custom');
};
exports.loadNewCurrencyFormat = loadNewCurrencyFormat;
Number.prototype.toPointsFormat = function () {
    return (0, numeral_1.default)(this).format(config_1.react_core_config.internalConfig.pointsFormat);
};
Number.prototype.toPointsFormatWithUnit = function () {
    return `${(0, numeral_1.default)(this).format(config_1.react_core_config.internalConfig.pointsFormat)} Point${this.valueOf() !== 1 ? 's' : ''}`;
};
Number.prototype.toPointsFormatWithLowerCaseUnit = function () {
    return this.toPointsFormatWithUnit().toLowerCase();
};
Number.prototype.getPointsUnit = function () {
    return `Point${this.valueOf() !== 1 ? 's' : ''}`;
};
Number.prototype.getPtsUnit = function () {
    return `Pt${this.valueOf() !== 1 ? 's' : ''}`;
};
Number.prototype.toCurrencyFormat = function () {
    return (0, numeral_1.default)(this).format(config_1.react_core_config.internalConfig.currencyFormat);
};
Number.prototype.toCurrencyFormatWithDecimal = function () {
    return (0, numeral_1.default)(this).format(config_1.react_core_config.internalConfig.currencyFormatWithDecimal);
};
Number.prototype.toCurrencyFormatExtended = function () {
    if (this.toString().length > 6) {
        return (0, numeral_1.default)(this).format('($0[.]0 a)');
    }
    else {
        return (0, numeral_1.default)(this).format('$0,0');
    }
};
Number.prototype.toCurrencyFormatWithTwoDigitsExtended = function () {
    return (0, numeral_1.default)(this).format('($0[.]00 a)').trimEnd();
};
//# sourceMappingURL=NumberUtil.js.map